import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

import { LOAN_DURATION_OPTIONS_DE } from './LoanDurationDE';
import { LOAN_PURPOSE_OPTIONS_DE } from './LoanPurposeDE';

type TLoanDurationValue = (typeof LOAN_DURATION_OPTIONS_DE)[number]['value'];
type TLoanPurposeValue = (typeof LOAN_PURPOSE_OPTIONS_DE)[number]['value'];

export const schema = yup.object().shape({
  email: yup
    .string()
    .email('Bitte geben Sie eine gültige E-Mail-Adresse ein')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      excludeEmptyString: true,
    })
    .required('benötigt'),
  amount: yup
    .string()
    .required('benötigt')
    .test(
      'requestedAmountMin',
      'Geben Sie einen Betrag ab 1.000€ an',
      (value) => {
        const numericValue = currencyToNumber(value, {
          currencySymbol: true,
          locale: 'de-DE',
          minorUnits: false,
        });
        if (!numericValue) return false;
        return numericValue >= 1000;
      },
    )
    .test(
      'requestedAmountMax',
      'Geben Sie einen Betrag bis max. 500.000€ an',
      (value) => {
        const numericValue = currencyToNumber(value, {
          currencySymbol: true,
          locale: 'de-DE',
          minorUnits: false,
        });
        if (!numericValue) return false;
        return numericValue <= 500000;
      },
    ),
  loanDuration: yup.string<TLoanDurationValue>().required('benötigt'),
  loanPurpose: yup.string<TLoanPurposeValue>().required('benötigt'),
  loanPurposeDetails: yup.string().when('loanPurpose', {
    is: 'other',
    then: (schema) => schema.required('benötigt'),
  }),
  marketingOptIn: yup.boolean().optional(),
  referralCode: yup.string().optional(),
});
